import { LABELS } from '@/constants/common/message.constants'

import { type ToursListExEntity } from '../..'

/**
 * 運行実績ステータス
 */
export type ChargeStatusType = ToursListExEntity['status']

export const CHARGE_STATUS_TYPE = {
  /** センター事前入力 */
  DC_PRE_ENTRY: 'DC_PRE_ENTRY',
  /** パートナー確認中 */
  PARTNER_PENDING: 'PARTNER_PENDING',
  /** 確認待ち */
  DC_PENDING: 'DC_PENDING',
  /** 確定済 */
  CONFIRMED: 'CONFIRMED',
  /** パートナー再確認待ち（差し戻し） */
  REJECTED: 'REJECTED'
} as const satisfies Record<ChargeStatusType, ChargeStatusType>

export const CHARGE_STATUS_TYPE_LABEL = {
  [CHARGE_STATUS_TYPE.DC_PRE_ENTRY]: LABELS.DC_PRE_ENTRY,
  [CHARGE_STATUS_TYPE.PARTNER_PENDING]: LABELS.PARTNER_PENDING,
  [CHARGE_STATUS_TYPE.DC_PENDING]: LABELS.DC_PENDING,
  [CHARGE_STATUS_TYPE.CONFIRMED]: LABELS.CONFIRMED,
  [CHARGE_STATUS_TYPE.REJECTED]: LABELS.PARTNER_RECONFIRMING
} as const satisfies Record<ChargeStatusType, string>
